import { AppConfig } from 'config';

const LOCAL_HOSTNAMES = ['localhost', '127.0.0.1'];

/**
 * Whether debug-only affordances (currently the onboarding replay) may run.
 *
 * Fail-closed on every path: a non-browser context, an unrecognised host and any throw all
 * return false. Production (`study.traineracademy.org` against `https://api.traineracademy.org`)
 * matches none of the branches below, so the replay query param is inert there rather than
 * merely hidden.
 */
export const areDebugToolsEnabled = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }

  try {
    // CRA inlines REACT_APP_* at build time, so an unset var compiles to `false`.
    if (AppConfig.ENABLE_DEBUG_TOOLS) {
      return true;
    }

    const { hostname } = window.location;

    if (LOCAL_HOSTNAMES.includes(hostname) || hostname.endsWith('.vercel.app')) {
      return true;
    }

    // Staging points at https://staging-api.traineracademy.org; production at https://api.traineracademy.org.
    return Boolean(AppConfig.BASE_API_URL?.includes('staging'));
  } catch {
    return false;
  }
};
